import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, P } from 'ui/acro'
import { ChevronRightIcon } from 'components_v2/Icons'
import { HeaderCTAText, HeaderText, AltHeaderText } from '../../styles'

const SectionHeader = ({
  headerText,
  linkId,
  linkHref,
  cta,
  target,
  isMain,
  desc,
  ctaIcon = true
}) => {
  return (
    <>
      <Flex
        px={['16px', '16px', '16px', '0px']}
        mb={!desc && ['16px', '16px', '16px', '24px']}
        mt={['16px', '16px', '16px', '0px']}
        justifyContent='space-between'
        alignItems='center'
      >
        {isMain ? (
          <HeaderText as='div'>{headerText}</HeaderText>
        ) : (
          <AltHeaderText as='div'>{headerText}</AltHeaderText>
        )}
        <HeaderCTAText
          id={linkId}
          as='a'
          className='unstyled'
          href={linkHref}
          target={target}
        >
          <span>{cta}</span>
          {cta && (
            <Box
              display={['none', null, null, 'inline-block']}
            >
              {' '}
              {ctaIcon && <ChevronRightIcon isBold={true} color='black' />}
            </Box>
          )}
        </HeaderCTAText>
      </Flex>
      {desc && (
        <P
          px={['16px', '16px', '16px', '0px']}
          mb={['16px', '16px', '16px', '24px']}
          mt={['0', '10px', '10px', '12px']}
        >
          {desc}
        </P>
      )}
    </>
  )
}

SectionHeader.propTypes = {
  headerText: PropTypes.string.isRequired,
  linkId: PropTypes.string,
  linkHref: PropTypes.string,
  cta: PropTypes.string,
  target: PropTypes.string
}

export default SectionHeader
